import { render, staticRenderFns } from "./InventoryUnitDetails.vue?vue&type=template&id=038480b6"
import script from "./InventoryUnitDetails.vue?vue&type=script&lang=js"
export * from "./InventoryUnitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038480b6')) {
      api.createRecord('038480b6', component.options)
    } else {
      api.reload('038480b6', component.options)
    }
    module.hot.accept("./InventoryUnitDetails.vue?vue&type=template&id=038480b6", function () {
      api.rerender('038480b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/InventoryUnitDetails.vue"
export default component.exports